import { render } from "./top-block.vue?vue&type=template&id=191e65c9&scoped=true"
const script = {}

import "./top-block.vue?vue&type=style&index=0&id=191e65c9&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-191e65c9"]])

export default __exports__